<div class="credits-content-header">
  <div class="credits-item">
    <h3>Meu saldo disponível</h3>
    <div class="credits-item-show">
      <h3 [hidden]="!showCredits">{{ user?.credits }} crédito(s)</h3>
      <h3 class="hidden-credits" [hidden]="showCredits"></h3>
      <ion-img
        [src]="'assets/icon/home/eye.png'"
        [alt]="'Mostrar saldo'"
        (click)="showCredits = !showCredits; onClickShow()"
      ></ion-img>
    </div>
  </div>
  <div class="credits-item extract" (click)="onClickExtract()">
    <h3>Ver extrato</h3>
  </div>
</div>
